import { isSubscriptionAndPaywallEnabled } from "@/constants/feature-flags";
import { useUser } from "@clerk/clerk-react";

export const useIsSubscriptionEnabled = () => {
  const { isLoaded } = useUser();
  return {
    isEnabled: isSubscriptionAndPaywallEnabled(),
    isResolved: isLoaded,
  };
};
